var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"breadcrumbs"},[_vm._l((_vm.breadcrumbs),function(item){return _c('div',{key:item.title,staticClass:"item"},[_vm._v(" "+_vm._s(item.title)+" ")])}),_c('div',{staticClass:"item"},[_vm._v(" "+_vm._s(_vm.data)+" ")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }